import { Modal } from "antd";
import { ParkingRevenueStatsByDate } from "../api/models";
import moment from "moment";
import { formatCurrencyCents } from "../utils";

export interface Props {
    onClose: () => void;
    provider: string;
    data: ParkingRevenueStatsByDate[];
}

const ParkingRevenueBreakdown = (props: Props) => {
    const title = "Daily Breakdown (" + props.provider + ")";

    const data = props.data.slice().reverse().filter(d => {
        return d.stats.find(s => s.provider == props.provider) != null;
    });

    return (
        <Modal open onOk={props.onClose} onCancel={props.onClose} cancelButtonProps={{ style: { display: 'none' } }} title={title} width="800px">
            <table className="w-full">
                <thead>
                    <tr>
                        <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Date</th>
                        <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Revenue (USD)</th>
                        <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Clicks</th>
                        <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Visitors</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((d) => {
                        const stats = d.stats.find(s => s.provider == props.provider);
                        return (
                            <tr key={d.date.toISOString()} className="border-t border-border hover:bg-bg-elevated transition-colors">
                                <td className="py-2 px-3 text-sm text-text">{moment(d.date).utc().format('LL')}</td>
                                <td className="py-2 px-3 text-right font-mono text-sm text-text tabular-nums">{formatCurrencyCents(stats?.revenue)}</td>
                                <td className="py-2 px-3 text-right font-mono text-sm text-text-2 tabular-nums">{stats?.clicks?.toLocaleString()}</td>
                                <td className="py-2 px-3 text-right font-mono text-sm text-text-2 tabular-nums">{stats?.visitors?.toLocaleString()}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </Modal>
    );
};
export default ParkingRevenueBreakdown;
